import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

//Componentes
//import Login from './components/admin/Login.vue';

const page="./components/page/";

const MyRouter = new VueRouter({
  	routes:[
	    { path: '/', name: 'preHomePage', component: require(page+'home/pre-home.vue').default },
	    { path: '/home', component: require(page+'home/home.vue').default },
      { path: '/empresa', component: require(page+'company/index.vue').default, meta:{ title:"Empresa" }},
      { path: '/beneficios', component: require(page+'benefits/index.vue').default, meta:{ title:"Beneficios" }},
      { path: '/contacto', component: require(page+'contact/index.vue').default, meta:{ title:"Contacto" }},
      { path: '/preguntas-frecuentes', component: require(page+'faqs/index.vue').default, meta:{ title:"Preguntas frecuentes" }},

      { path: '/productos', component: require(page+'products/results.vue').default, meta:{ title:"Productos" }},
      { path: '/busqueda', component: require(page+'products/results.vue').default, meta:{ title:"Productos" }},
      { path: '/producto/:id', component: require(page+'products/description.vue').default, meta:{ title:"Producto" }},

      { path: '/blog', component: require(page+'blog/index.vue').default, meta:{ title:"Blog" } },
      { path: '/blog/:id', component: require(page+'blog/detail.vue').default, meta:{ title:"Blog" } },

      { path: '/aviso-de-privacidad', component: require(page+'text-pages/aviso.vue').default, meta:{ title:"Aviso de privacidad" } },
      { path: '/terminos-y-condiciones', component: require(page+'text-pages/terminos.vue').default, meta:{ title:"Términos y condiciones" } },
      { path: '/condiciones-y-clausula-de-afiliaciones', component: require(page+'text-pages/condiciones-afiliaciones.vue').default, meta:{ title:"Condiciones y Clausula de Afiliaciones" } },

      { path: '/cart/:step?', component: require(page+'carrito/index.vue').default, meta:{title:"Mi carrito de compras"}},
      // { path: '/historial-de-compras', component: require(page+'carrito/historial.vue').default, meta:{title:"Mi historial de compras"}},
      // { path: '/mis-favoritos', component: require(page+'carrito/mis-favoritos.vue').default, meta:{title:"Mis favoritos"}},

      { path: '/afiliate', component: require(page+'join/index.vue').default, meta:{title:"Afíliate"}},
      { path: '/login', component: require(page+'user-access/login.vue').default, meta:{title:"Iniciar sesión"}},
      { path: '/recuperar-contrasena', component: require(page+'user-access/reset-password.vue').default, meta:{title:"Recuperar contraseña"}},
      // { path: '/registrarse', component: require(page+'user-access/register.vue').default, meta:{title:"Registrarse"}},

      { path: '/usuario', component: require(page+'usuario-cuenta/index.vue').default, meta:{ title: 'Mi datos' },
  			children: [
  			{
  				path: '/',
  				component: require(page+'usuario-cuenta/mis-datos.vue').default,
  				meta:{ title: 'Mis datos' }
  			},
  			{
  				path: 'contrasena',
  				component: require(page+'usuario-cuenta/contrasena.vue').default,
  				meta:{ title: 'Cambiar contraseña' }
  			},
        // {
        //     path: 'historial-compras',
        //     component: require(page+'usuario-cuenta/historial-compras.vue').default,
        //     meta:{ title: 'Mis pedidos' }
        // },
        {
            path: 'pedido/:id',
            component: require(page+'usuario-cuenta/orderdetails.vue').default,
            meta:{ title: 'Mis pedidos' }
        },
  	  	]
  		},

	    // { path: '/checkout', component: require(page+'checkout.vue').default, meta:{title:"Checkout"}},
	  ]
});

MyRouter.beforeEach((to, from, next) => {
	window.scrollTo(0,0);
	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		window.app.__vue__.$refs.loadingBar.start();
	}
	next();
});

MyRouter.afterEach((to, from) => {

	if(window.app.__vue__ && window.app.__vue__.$refs.loadingBar){
		setTimeout(()=>{
			window.app.__vue__.$refs.loadingBar.done();
		},500);
	}


});

//Titulos del website
import VueDocumentTitlePlugin from "vue-document-title-plugin";
Vue.use(VueDocumentTitlePlugin, MyRouter,
	{ defTitle: "Feros, Mejora tu calidad de vida con complementos naturales", filter: (title)=>{ return title+" - Feros, Mejora tu calidad de vida con complementos naturales"; } }
);

// export {routes};
export default MyRouter;
